// Centralised static-asset imports.
// Keeping them in one place means webpack fingerprints + bundles them, the
// production build is self-hosted (no runtime fetch from customer-assets.emergentagent.com),
// and future image swaps happen in a single file.

import logo from './logo.png';
import logoDark from './logo-dark.png';
import logoV1 from './logo-v1.png';
import logoHorizontal from './logo-horizontal.png';
import landingBackground from './landing-background.png';
import landingSharingPhoto from './landing-sharing-photo.jpg';
import discoverMockup from './discover-mockup.webp';

import avatarWomanLight from './avatar-woman-light.png';
import avatarWomanHijab from './avatar-woman-hijab.png';
import avatarManDark from './avatar-man-dark.png';

import giveawayHammer from './giveaway-hammer.png';
import giveawaySaw from './giveaway-saw.png';
import giveawayTrowel from './giveaway-trowel.png';
import giveawayLaptop from './giveaway-laptop.png';
import giveawayGear from './giveaway-gear.png';

export {
  logo, logoDark, logoV1, logoHorizontal,
  landingBackground, landingSharingPhoto, discoverMockup,
  avatarWomanLight, avatarWomanHijab, avatarManDark,
};

// Default giveaway thumbnails users can pick when creating a listing without
// uploading their own photo. Order matches the original hardcoded array.
export const GIVEAWAY_PRESETS = [
  { url: giveawayHammer, label: 'Hammer' },
  { url: giveawaySaw, label: 'Circular Saw' },
  { url: giveawayTrowel, label: 'Trowel' },
  { url: giveawayLaptop, label: 'Laptop' },
  { url: giveawayGear, label: 'Gear' },
];
